module.exports = __webpack_public_path__ + "static/media/arrow-top-gray.7bb8410b.svg";